<tidy-card class="upgrade-card" (click)="onCardClick()">
  <div class="upgrade-card__header">
    <tidy-card-icon-block [iconSrc]="iconSrc" [variant]="impactClass" />
    <div class="upgrade-card__title">
      <tidy-text [header]="upgrade.name" [translate]="false" />
      @if (upgrade.description) {
        <tidy-text [body]="upgrade.description" [translate]="false" class="upgrade-card__description" />
      }
    </div>
    @if (upgrade.status === 'requested' && requestedDaysAgo) {
      <span class="upgrade-card__requested-pill">Requested {{ requestedDaysAgo }}</span>
    }
  </div>

  <div class="upgrade-card__stats">
    <div class="upgrade-card__stat">
      <div class="upgrade-card__stat-label">Cost</div>
      <div class="upgrade-card__stat-value">{{ costLabel }}</div>
    </div>
    <div class="upgrade-card__stat">
      <div class="upgrade-card__stat-label">Impact</div>
      <div class="upgrade-card__stat-value">
        <tidy-impact-pill [label]="impactLabel" [impactClass]="impactClass" />
      </div>
    </div>
    <div class="upgrade-card__stat">
      <div class="upgrade-card__stat-label">ROI</div>
      <div class="upgrade-card__stat-value">
        <tidy-roi-bar [score]="upgrade.roi_score" [label]="roiLabel" [percent]="roiPercent" />
      </div>
    </div>
  </div>

  <div class="upgrade-card__actions" (click)="stopPropagation($event)">
    @for (option of statusOptions; track option.value) {
      <tidy-small-button
        [text]="option.viewValue"
        [primary]="upgrade.status === option.value"
        (buttonClick)="onStatusSelect(option.value)" />
    }
  </div>
</tidy-card>
